import { forwardRef } from "react";
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";

import {
  type TRadioGroupIndicatorElement,
  type TRadioGroupIndicatorProps,
} from "@/ui/components/form/RadioGroup/RadioGroup.config";
import { cn } from "@/ui/lib/utils";

export const RadioGroupIndicator = forwardRef<TRadioGroupIndicatorElement, TRadioGroupIndicatorProps>(
  (
    {
      className,
      ...props
    },
    ref,
  ) => (
    <RadioGroupPrimitive.Indicator
      {...props}
      ref={ref}
      data-component="RadioGroupIndicator"
      className={cn(
        "block h-2 w-2 rounded-full bg-component-checkbox-check-checked",
        className,
      )}
    />
  ),
);

RadioGroupIndicator.displayName = RadioGroupPrimitive.Indicator.displayName;
